export var featuresToShow = {
  cards: {
    large: ['return', 'risk', 'cost', 'fiscality'],
    cta: ['return', 'cost']
  }
};
export var reviewsFeaturesCatalog = [{
  alias: 'return',
  name: 'Rentabilidad',
  description: 'Rentabilidad'
}, {
  alias: 'risk',
  name: 'Riesgo',
  description: 'Riesgo'
}, {
  alias: 'liquidity',
  name: 'Liquidez',
  description: 'Liquidez'
}, {
  alias: 'complexity',
  name: 'Complejidad',
  description: 'Complejidad'
}, {
  alias: 'diversification',
  name: 'Diversificación',
  description: 'Diversificación'
}, {
  alias: 'size',
  name: 'Tamaño',
  description: 'Tamaño'
}, {
  alias: 'accesibility',
  name: 'Accesibilidad',
  description: 'Compra'
}, {
  alias: 'fiscality',
  name: 'Fiscalidad',
  description: 'Fiscalidad'
}, {
  alias: 'term',
  name: 'Horizonte temporal',
  description: 'Plazo'
}, {
  alias: 'stability',
  name: 'Estabilidad',
  description: 'Estabilidad'
}, {
  alias: 'cost',
  name: 'Coste competitivo',
  description: 'Coste competitivo'
}];